import { Text } from 'components/Text';
import { ShiftWorkLocation } from '../types';
import { getWorkLocationAddressLine } from '../utils';

export const WorkLocationView = ({
  location
}: {
  location: ShiftWorkLocation;
}) => {
  const addressLine = getWorkLocationAddressLine(location);

  return (
    <div data-testid="shift-work-location">
      {location.name && (
        <Text color="textPrimary" sx={{ fontWeight: 700 }}>
          {location.name}
        </Text>
      )}
      {addressLine && <Text variant="body2">{addressLine}</Text>}
    </div>
  );
};
